export interface BrandingState {
  slug: string;
  title: string;
  logo_uri: string;
  favicon_uri: string;
  primary_color: string;
  loaded: boolean;
}

export const BRANDING_STORAGE_KEY = "tenant_branding";

/**
 * Read any persisted branding so it survives the SSO redirect and page reloads.
 */
export function loadPersistedBranding(): BrandingState {
  const empty: BrandingState = {
    slug: "",
    title: "",
    logo_uri: "",
    favicon_uri: "",
    primary_color: "",
    loaded: false
  };
  try {
    const raw = localStorage.getItem(BRANDING_STORAGE_KEY);
    if (!raw) return empty;
    return { ...empty, ...JSON.parse(raw), loaded: true };
  } catch {
    return empty;
  }
}
